

<template>

    <div>

    <div class="container">
      <div>
        <el-carousel :interval="4000" arrow="always">
          <el-carousel-item v-for="item in carouselChartlist" :key="item.id">

            <el-image style="width:560px;height: 280px"
                    :src="'https://localhost:8090/hsq/file/'+item.img"/>
          </el-carousel-item>
        </el-carousel>
      </div>
      <el-tabs type="border-card">
        <el-tab-pane label="全部">
          <el-space wrap>
            <div style="display: flex; flex-wrap: wrap; ">
              <div v-for="item in items" :key="item.id" class="box-card" style="background-color: #efdede; margin: 7px; display: flex;">
                <div style="padding: 10px">
                <el-image style="width: 150px; height: 180px;" :src="'https://localhost:8090/hsq/file/' + item.cover"/>
                </div>
                <div style="width: 130px;margin: 10px;text-align: left">
                  <a @click="navTo('/novelchapters?id='+item.id)">{{ item.title }}</a>
                  <p>{{ item.username }}</p>
                  <p>{{ item.typeName }}</p>
                  <p>{{item.description}}</p>
                  <div v-for="r in ratings" :key="r.id">
                  <p v-if="r.nid===item.id">{{r.rating}}分</p>
                  </div>
                </div>
              </div>
            </div>
          </el-space>
        </el-tab-pane>



      <el-tab-pane label="Config"><li>
        <div class="book-img">
          <a href="/book/26472219809737504" target="_blank" title="开局就被赶出豪门">
            <img src="//bookcover.yuewen.com/qdbimg/349573/c_26472219809737504/90.webp" alt="开局就被赶出豪门">
          </a>
        </div>
        <div class="book-info">
          <h3><a href="/book/26472219809737504" target="_blank" title="开局就被赶出豪门">开局就被赶出豪门</a></h3>
          <h4><a class="default">一路烦花</a></h4>
          <p class="tag"><span class="org">现代言情</span><span class="pink">连载中</span><span class="blue">138.54万</span></p>
          <p class="intro">
           {{ratings}}{{items}}
          </p>
        </div>
      </li></el-tab-pane>
      <el-tab-pane label="Role">Role</el-tab-pane>
      <el-tab-pane label="Task">Task</el-tab-pane>
    </el-tabs>
  </div>
  </div>

</template>

<style scoped>
.container {

position: relative;
  left: 20%;
  padding: 0;
  width: 60%;
  height:100vh;
  background-color: #cccccc;
}

.item {
  margin-right: 40px;
}
</style>
<script>
import request from "@/utils/request";

import CryptoJS from "crypto-js";
import router from "@/router";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name:'novels',

  data(){
    return{
      params: {
        title: "",
        username: "",
        pageNum:1,
        pageSize:10,
      },
      total:0,
      items:[],
      ratings:[],
      carouselChartlist:""
    }
  },
  methods:{
    getnoverl(){


        request.get('/novel/get',{params:this.params}).then(res=>{

          if (res.code === '1') {
            this.items = res.data.list;
            this.total=res.data.total;
request.post('rating/getAverageRatingForNovels',this.items).then(res=>{
  this.ratings=res.data;
})

          } else {
            this.$message({
              message:res.msg,
              type: 'error'
            });
          }

        })

      },
    zhanshi(item){
      console.log(item)
      const data=JSON.stringify(item);
      const encryptedData = CryptoJS.AES.encrypt(data, 'secretKey').toString();
      router.push({
        name: 'novelchapters',
        query: { data:encryptedData}
      });
    },
    navTo(url){
      location.href=url;
    },
    getcarouselChart() {  // 分页查询

      request.get('/carouselChart/selectPage', {
        params: {
          pageNum: 1,
          pageSize: 100,
          router: "/novels",
        }
      }).then(res => {
        if (res.code === '1') {
          this.carouselChartlist = res.data.list

        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
  mounted() {
    this.getnoverl()
    this.getcarouselChart()
  }

}
</script>